<template>
  <div class="dob-fields" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
      <div class="row">
        <div class="col-4 day-holder">
          <select class="form-select" id="birth-month" v-model="currentMonth" :disabled="elementDisabled">
            <option selected :value="null">Month</option>
            <option v-for="m in 12" :value="m" :key="m">{{m}}</option>
          </select>
        </div>
        <div class="col-4">
          <select class="form-select" id="birth-day" v-model="currentDay" :disabled="elementDisabled">
            <option selected :value="null">Day</option>
            <option v-for="d in 31" :value="d" :key="d">{{d}}</option>
          </select>
        </div>
        <div class="col-4">
          <select class="form-select" id="birth-year" v-model="currentYear" :disabled="elementDisabled">
            <option selected :value="null">Year</option>
            <option v-for="m in birthYears" :value="m" :key="m">{{m}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'DobFields',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    var birthYears = []
    var currentYear = (new Date()).getFullYear()
    for (let k = currentYear - 84; k <= currentYear - 17; k++) {
      birthYears.push(k)
    }
    return {
      birthYears,
      realYear: currentYear
    }
  },
  computed: {
    dateSplit () {
      return this.currentValue ? this.currentValue.split('-').map((v) => v === 'null' ? null : v) : [null, null, null]
    },
    currentYear: {
      get () {
        return this.dateSplit[0]
      },
      set (year) {
        this.currentValue = `${year}-${this.dateSplit[1] ?? 'null'}-${this.dateSplit[2] ?? 'null'}`
      }
    },
    currentMonth: {
      get () {
        return this.dateSplit[1] && this.dateSplit[1].charAt(0) === '0'
          ? this.dateSplit[1].slice(1)
          : this.dateSplit[1]
      },
      set (month) {
        this.currentValue = `${this.dateSplit[0] ?? 'null'}-${month < 10 ? '0' + month : month}-${this.dateSplit[2] ?? 'null'}`
      }
    },
    currentDay: {
      get () {
        return this.dateSplit[2] && this.dateSplit[2].charAt(0) === '0'
          ? this.dateSplit[2].slice(1)
          : this.dateSplit[2]
      },
      set (day) {
        this.currentValue = `${this.dateSplit[0] ?? 'null'}-${this.dateSplit[1] ?? 'null'}-${day < 10 ? '0' + day : day}`
      }
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
